<div class="radio-group">
  <div class="form-check" *ngFor="let option of options; let i = index">
    <div class="form-check-label-container">
      <label class="form-check-label-font" [for]="option.descricao">
        {{ option.titulo }}<br><small>{{ option.descricao | cpfcnpj }}</small>
      </label>
    </div>
    <input
      class="form-check-input-new"
      type="radio"
      name="radioOptions"
      [id]="option.descricao"
      [value]="option.id"
      [(ngModel)]="selectedOption"
      (change)="selectOption(option.id, option.descricao)">
  </div>
</div>